import { Skeleton } from '@/ui'

/**
 * 结账页面 骨架屏
 */
const CheckoutSkeleton = () => {
  return (
    <div className="p-3 xl:m-auto xl:max-w-[1440px]">
      {/* Mobile */}
      <div className="space-y-2 xl:hidden">
        <Skeleton className="h-[35px] w-[125px]" />
        <Skeleton className="h-[48px]" />
        <div className="pt-2">
          <Skeleton className="h-[35px] w-[125px]" />
        </div>
        <div className="my-3 flex justify-start space-x-2">
          <Skeleton className="h-[48px] w-[50%] rounded-[8px]" />
          <Skeleton className="h-[48px] w-[50%] rounded-[8px]" />
        </div>
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
        <div className="pt-2">
          <Skeleton className="h-[35px] w-[125px]" />
        </div>
        <Skeleton className="h-[48px] rounded-[8px]" />
        <Skeleton className="h-[48px] rounded-[8px]" />
      </div>

      {/* Desktop */}
      <div className="space-y-[60px] max-xl:hidden">
        <div className="my-7 flex justify-start space-x-3">
          <Skeleton className="h-[45px] w-[200px]" />
          <Skeleton className="h-[45px] w-[200px]" />
        </div>
        <div className="flex flex-row pb-[8.8rem]">
          <div className="flex-1 space-y-[66px]">
            <div className="space-y-4">
              <Skeleton className="h-[35px] w-[200px] rounded-full" />
              <Skeleton className="h-[90px] w-full rounded-[8px]" />
            </div>
            <div className="space-y-4">
              <Skeleton className="h-[35px] w-[200px] rounded-full" />
              <Skeleton className="h-[90px] w-full rounded-[8px]" />
              <Skeleton className="h-[90px] w-full rounded-[8px]" />
            </div>
            <div className="space-y-4">
              <Skeleton className="h-[35px] w-[200px] rounded-full" />
              <div className="space-3 grid grid-cols-[1fr_1fr] gap-3">
                <Skeleton className="h-[48px] rounded-[8px]" />
                <Skeleton className="h-[48px] rounded-[8px]" />
              </div>
              <Skeleton className="h-[48px] w-full rounded-[8px]" />
              <Skeleton className="h-[48px] w-full rounded-[8px]" />
              <Skeleton className="h-[48px] w-full rounded-[8px]" />
              <Skeleton className="h-[48px] w-full rounded-[8px]" />
              <Skeleton className="h-[48px] w-full rounded-[8px]" />
              <Skeleton className="h-[48px] w-full rounded-[8px]" />
              <Skeleton className="h-[48px] w-full rounded-[8px]" />
            </div>
          </div>
          <div className="mx-[7.6rem] w-px bg-black/15"></div>
          <div className="w-[41.5rem] flex-none space-y-5">
            <div className="flex justify-between">
              <Skeleton className="h-[36px] w-[176px]" />
              <Skeleton className="h-[36px] w-[80px]" />
            </div>
            <Skeleton className="h-[36px] w-[176px]" />
            <div>
              {new Array(3).fill(0).map((_, index) => (
                <div key={index}>
                  <div className="py-3">
                    <div className="flex">
                      <Skeleton className="mb-0 aspect-square h-auto w-[88px] flex-none self-start rounded-[8px]" />
                      <div className="flex flex-1 flex-col space-y-3 pl-7">
                        <Skeleton className="h-7" />
                        <Skeleton className="h-7 w-[100px]" />
                        <Skeleton className="h-7 w-[100px]" />
                      </div>
                    </div>
                  </div>
                  {index < 3 && <div className="h-[1px] bg-gray-1"></div>}
                </div>
              ))}
            </div>
            <Skeleton className="h-[36px] w-[176px]" />
            <div className="flex justify-between">
              <Skeleton className="h-[36px] w-[80px]" />
              <Skeleton className="h-[36px] w-[80px]" />
            </div>
            <Skeleton className="h-[46px]" />
            {new Array(3).fill(0).map((_, index) => (
              <div key={index} className="flex justify-between">
                <Skeleton className="h-[36px] w-[66px]" />
                <Skeleton className="h-[36px] w-[66px]" />
              </div>
            ))}
            <Skeleton className="h-[90px]" />
          </div>
        </div>
      </div>
    </div>
  )
}
export default CheckoutSkeleton
